function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/element
 */
import Node from './node';
import Text from './text';
import TextProxy from './textproxy';
import toMap from '@ckeditor/ckeditor5-utils/src/tomap';
import toArray from '@ckeditor/ckeditor5-utils/src/toarray';
import isIterable from '@ckeditor/ckeditor5-utils/src/isiterable';
import Matcher from './matcher';
import StylesMap from './stylesmap'; // @if CK_DEBUG_ENGINE // const { convertMapToTags } = require( '../dev-utils/utils' );

/**
 * View element.
 *
 * The editing engine does not define a fixed semantics of its elements (it is "DTD-free").
 * This is why the type of the {@link module:engine/view/element~Element} need to
 * be defined by the feature developer. When creating an element you should use one of the following methods:
 *
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createContainerElement `downcastWriter#createContainerElement()`}
 * in order to create a {@link module:engine/view/containerelement~ContainerElement},
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createAttributeElement `downcastWriter#createAttributeElement()`}
 * in order to create a {@link module:engine/view/attributeelement~AttributeElement},
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createEmptyElement `downcastWriter#createEmptyElement()`}
 * in order to create a {@link module:engine/view/emptyelement~EmptyElement}.
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createUIElement `downcastWriter#createUIElement()`}
 * in order to create a {@link module:engine/view/uielement~UIElement}.
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createEditableElement `downcastWriter#createEditableElement()`}
 * in order to create a {@link module:engine/view/editableelement~EditableElement}.
 *
 * Note that for view elements which are not created from the model, like elements from mutations, paste or
 * {@link module:engine/controller/datacontroller~DataController#set data.set} it is not possible to define the type of the element.
 * In such cases the {@link module:engine/view/upcastwriter~UpcastWriter#createElement `UpcastWriter#createElement()`} method
 * should be used to create generic view elements.
 *
 * @extends module:engine/view/node~Node
 */

var Element = /*#__PURE__*/function (_Node) {
  _inherits(Element, _Node);

  var _super = _createSuper(Element);

  /**
   * Creates a view element.
   *
   * Attributes can be passed in various formats:
   *
   *		new Element( viewDocument, 'div', { class: 'editor', contentEditable: 'true' } ); // object
   *		new Element( viewDocument, 'div', [ [ 'class', 'editor' ], [ 'contentEditable', 'true' ] ] ); // map-like iterator
   *		new Element( viewDocument, 'div', mapOfAttributes ); // map
   *
   * @protected
   * @param {module:engine/view/document~Document} document The document instance to which this element belongs.
   * @param {String} name Node name.
   * @param {Object|Iterable} [attrs] Collection of attributes.
   * @param {module:engine/view/node~Node|Iterable.<module:engine/view/node~Node>} [children]
   * A list of nodes to be inserted into created element.
   */
  function Element(document, name, attrs, children) {
    var _this;

    _classCallCheck(this, Element);

    _this = _super.call(this, document);
    /**
     * Name of the element.
     *
     * @readonly
     * @member {String}
     */

    _this.name = name;
    /**
     * Map of attributes, where attributes names are keys and attributes values are values.
     *
     * @protected
     * @member {Map} #_attrs
     */

    _this._attrs = parseAttributes(attrs);
    /**
     * Array of child nodes.
     *
     * @protected
     * @member {Array.<module:engine/view/node~Node>}
     */

    _this._children = [];

    if (children) {
      _this._insertChild(0, children);
    }
    /**
     * Set of classes associated with element instance.
     *
     * @protected
     * @member {Set}
     */


    _this._classes = new Set();

    if (_this._attrs.has('class')) {
      // Remove class attribute and handle it by class set.
      var classString = _this._attrs.get('class');

      parseClasses(_this._classes, classString);

      _this._attrs.delete('class');
    }
    /**
     * Normalized styles.
     *
     * @protected
     * @member {module:engine/view/stylesmap~StylesMap} module:engine/view/element~Element#_styles
     */


    _this._styles = new StylesMap(_this.document.stylesProcessor);

    if (_this._attrs.has('style')) {
      // Remove style attribute and handle it by styles map.
      _this._styles.setTo(_this._attrs.get('style'));

      _this._attrs.delete('style');
    }
    /**
     * Map of custom properties.
     * Custom properties can be added to element instance, will be cloned but not rendered into DOM.
     *
     * @protected
     * @member {Map}
     */


    _this._customProperties = new Map();
    /**
     * Whether an element is allowed inside an AttributeElement and can be wrapped with
     * {@link module:engine/view/attributeelement~AttributeElement} by {@link module:engine/view/downcastwriter~DowncastWriter}.
     *
     * @protected
     * @member {Boolean}
     */

    _this._isAllowedInsideAttributeElement = false;
    return _this;
  }
  /**
   * Number of element's children.
   *
   * @readonly
   * @type {Number}
   */


  _createClass(Element, [{
    key: "childCount",
    get: function get() {
      return this._children.length;
    }
    /**
     * Is `true` if there are no nodes inside this element, `false` otherwise.
     *
     * @readonly
     * @type {Boolean}
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this._children.length === 0;
    }
    /**
     * Whether the element is allowed inside an AttributeElement and can be wrapped with
     * {@link module:engine/view/attributeelement~AttributeElement} by {@link module:engine/view/downcastwriter~DowncastWriter}.
     *
     * @readonly
     * @type {Boolean}
     */

  }, {
    key: "isAllowedInsideAttributeElement",
    get: function get() {
      return this._isAllowedInsideAttributeElement;
    }
    /**
     * Checks whether this object is of the given.
     *
     *		element.is( 'element' ); // -> true
     *		element.is( 'node' ); // -> true
     *		element.is( 'view:element' ); // -> true
     *		element.is( 'view:node' ); // -> true
     *
     *		element.is( 'model:element' ); // -> false
     *		element.is( 'documentSelection' ); // -> false
     *
     * Assuming that the object being checked is an element, you can also check its
     * {@link module:engine/view/element~Element#name name}:
     *
     *		element.is( 'element', 'img' ); // -> true if this is an <img> element
     *		text.is( 'element', 'img' ); -> false
     *
     * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
     *
     * @param {String} type Type to check.
     * @param {String} [name] Element name.
     * @returns {Boolean}
     */

  }, {
    key: "is",
    value: function is(type) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!name) {
        return type === 'element' || type === 'view:element' || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
        type === 'node' || type === 'view:node';
      } else {
        return name === this.name && (type === 'element' || type === 'view:element');
      }
    }
    /**
     * Gets child at the given index.
     *
     * @param {Number} index Index of child.
     * @returns {module:engine/view/node~Node} Child node.
     */

  }, {
    key: "getChild",
    value: function getChild(index) {
      return this._children[index];
    }
    /**
     * Gets index of the given child node. Returns `-1` if child node is not found.
     *
     * @param {module:engine/view/node~Node} node Child node.
     * @returns {Number} Index of the child node.
     */

  }, {
    key: "getChildIndex",
    value: function getChildIndex(node) {
      return this._children.indexOf(node);
    }
    /**
     * Gets child nodes iterator.
     *
     * @returns {Iterable.<module:engine/view/node~Node>} Child nodes iterator.
     */

  }, {
    key: "getChildren",
    value: function getChildren() {
      return this._children[Symbol.iterator]();
    }
    /**
     * Returns an iterator that contains the keys for attributes. Order of inserting attributes is not preserved.
     *
     * @returns {Iterable.<String>} Keys for attributes.
     */

  }, {
    key: "getAttributeKeys",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getAttributeKeys() {
      return _regeneratorRuntime.wrap(function getAttributeKeys$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this._classes.size > 0)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return 'class';

            case 3:
              if (this._styles.isEmpty) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return 'style';

            case 6:
              return _context.delegateYield(this._attrs.keys(), "t0", 7);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, getAttributeKeys, this);
    })
    /**
     * Returns iterator that iterates over this element's attributes.
     *
     * Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
     * This format is accepted by native `Map` object and also can be passed in `Node` constructor.
     *
     * @returns {Iterable.<*>}
     */

  }, {
    key: "getAttributes",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getAttributes() {
      return _regeneratorRuntime.wrap(function getAttributes$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.delegateYield(this._attrs.entries(), "t0", 1);

            case 1:
              if (!(this._classes.size > 0)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 4;
              return ['class', this.getAttribute('class')];

            case 4:
              if (this._styles.isEmpty) {
                _context2.next = 7;
                break;
              }

              _context2.next = 7;
              return ['style', this.getAttribute('style')];

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, getAttributes, this);
    })
    /**
     * Gets attribute by key. If attribute is not present - returns undefined.
     *
     * @param {String} key Attribute key.
     * @returns {String|undefined} Attribute value.
     */

  }, {
    key: "getAttribute",
    value: function getAttribute(key) {
      if (key == 'class') {
        if (this._classes.size > 0) {
          return _toConsumableArray(this._classes).join(' ');
        }

        return undefined;
      }

      if (key == 'style') {
        var inlineStyle = this._styles.toString();

        return inlineStyle == '' ? undefined : inlineStyle;
      }

      return this._attrs.get(key);
    }
    /**
     * Returns a boolean indicating whether an attribute with the specified key exists in the element.
     *
     * @param {String} key Attribute key.
     * @returns {Boolean} `true` if attribute with the specified key exists in the element, false otherwise.
     */

  }, {
    key: "hasAttribute",
    value: function hasAttribute(key) {
      if (key == 'class') {
        return this._classes.size > 0;
      }

      if (key == 'style') {
        return !this._styles.isEmpty;
      }

      return this._attrs.has(key);
    }
    /**
     * Checks if this element is similar to other element.
     * Both elements should have the same name and attributes to be considered as similar. Two similar elements
     * can contain different set of children nodes.
     *
     * @param {module:engine/view/element~Element} otherElement
     * @returns {Boolean}
     */

  }, {
    key: "isSimilar",
    value: function isSimilar(otherElement) {
      if (!(otherElement instanceof Element)) {
        return false;
      } // If exactly the same Element is provided - return true immediately.


      if (this === otherElement) {
        return true;
      } // Check element name.


      if (this.name != otherElement.name) {
        return false;
      } // Check isAllowedInsideAttributeElement property.


      if (this.isAllowedInsideAttributeElement != otherElement.isAllowedInsideAttributeElement) {
        return false;
      } // Check number of attributes, classes and styles.


      if (this._attrs.size !== otherElement._attrs.size || this._classes.size !== otherElement._classes.size || this._styles.size !== otherElement._styles.size) {
        return false;
      } // Check if attributes are the same.


      var _iterator = _createForOfIteratorHelper(this._attrs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (!otherElement._attrs.has(key) || otherElement._attrs.get(key) !== value) {
            return false;
          }
        } // Check if classes are the same.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this._classes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var className = _step2.value;

          if (!otherElement._classes.has(className)) {
            return false;
          }
        } // Check if styles are the same.

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this._styles.getStyleNames()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var property = _step3.value;

          if (!otherElement._styles.has(property) || otherElement._styles.getAsString(property) !== this._styles.getAsString(property)) {
            return false;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return true;
    }
    /**
     * Returns true if class is present.
     * If more then one class is provided - returns true only when all classes are present.
     *
     *		element.hasClass( 'foo' ); // Returns true if 'foo' class is present.
     *		element.hasClass( 'foo', 'bar' ); // Returns true if 'foo' and 'bar' classes are both present.
     *
     * @param {...String} className
     */

  }, {
    key: "hasClass",
    value: function hasClass() {
      for (var _len = arguments.length, className = new Array(_len), _key = 0; _key < _len; _key++) {
        className[_key] = arguments[_key];
      }

      for (var _i2 = 0, _className = className; _i2 < _className.length; _i2++) {
        var name = _className[_i2];

        if (!this._classes.has(name)) {
          return false;
        }
      }

      return true;
    }
    /**
     * Returns iterator that contains all class names.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "getClassNames",
    value: function getClassNames() {
      return this._classes.keys();
    }
    /**
     * Returns style value for the given property mae.
     * If the style does not exist `undefined` is returned.
     *
     * **Note**: This method can work with normalized style names if
     * {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
     * See {@link module:engine/view/stylesmap~StylesMap#getAsString `StylesMap#getAsString()`} for details.
     *
     * For an element with style set to `'margin:1px'`:
     *
     *		// Enable 'margin' shorthand processing:
     *		editor.data.addStyleProcessorRules( addMarginRules );
     *
     *		const element = view.change( writer => {
     *			const element = writer.createElement();
     *			writer.setStyle( 'margin', '1px' );
     *			writer.setStyle( 'margin-bottom', '3em' );
     *
     *			return element;
     *		} );
     *
     *		element.getStyle( 'margin' ); // -> 'margin: 1px 1px 3em;'
     *
     * @param {String} property
     * @returns {String|undefined}
     */

  }, {
    key: "getStyle",
    value: function getStyle(property) {
      return this._styles.getAsString(property);
    }
    /**
     * Returns a normalized style object or single style value.
     *
     * For an element with style set to: margin:1px 2px 3em;
     *
     *		element.getNormalizedStyle( 'margin' ) );
     *
     * will return:
     *
     *		{
     *			top: '1px',
     *			right: '2px',
     *			bottom: '3em',
     *			left: '2px'    // a normalized value from margin shorthand
     *		}
     *
     * and reading for single style value:
     *
     *		styles.getNormalizedStyle( 'margin-left' );
     *
     * Will return a `2px` string.
     *
     * **Note**: This method will return normalized values only if
     * {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
     * See {@link module:engine/view/stylesmap~StylesMap#getNormalized `StylesMap#getNormalized()`} for details.
     *
     *
     * @param {String} property Name of CSS property
     * @returns {Object|String|undefined}
     */

  }, {
    key: "getNormalizedStyle",
    value: function getNormalizedStyle(property) {
      return this._styles.getNormalized(property);
    }
    /**
     * Returns iterator that contains all style names.
     *
     * @param {Boolean} [expand=false] Expand shorthand style properties and return all equivalent style representations.
     * @returns {Iterable.<String>}
     */

  }, {
    key: "getStyleNames",
    value: function getStyleNames() {
      var expand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._styles.getStyleNames(expand);
    }
    /**
     * Returns true if style keys are present.
     * If more then one style property is provided - returns true only when all properties are present.
     *
     *		element.hasStyle( 'color' ); // Returns true if 'border-top' style is present.
     *		element.hasStyle( 'color', 'border-top' ); // Returns true if 'color' and 'border-top' styles are both present.
     *
     * @param {...String} property
     */

  }, {
    key: "hasStyle",
    value: function hasStyle() {
      for (var _len2 = arguments.length, property = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        property[_key2] = arguments[_key2];
      }

      for (var _i3 = 0, _property = property; _i3 < _property.length; _i3++) {
        var name = _property[_i3];

        if (!this._styles.has(name)) {
          return false;
        }
      }

      return true;
    }
    /**
     * Returns ancestor element that match specified pattern.
     * Provided patterns should be compatible with {@link module:engine/view/matcher~Matcher Matcher} as it is used internally.
     *
     * @see module:engine/view/matcher~Matcher
     * @param {Object|String|RegExp|Function} patterns Patterns used to match correct ancestor.
     * See {@link module:engine/view/matcher~Matcher}.
     * @returns {module:engine/view/element~Element|null} Found element or `null` if no matching ancestor was found.
     */

  }, {
    key: "findAncestor",
    value: function findAncestor() {
      for (var _len3 = arguments.length, patterns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        patterns[_key3] = arguments[_key3];
      }

      var matcher = _construct(Matcher, patterns);

      var parent = this.parent;

      while (parent) {
        if (matcher.match(parent)) {
          return parent;
        }

        parent = parent.parent;
      }

      return null;
    }
    /**
     * Returns the custom property value for the given key.
     *
     * @param {String|Symbol} key
     * @returns {*}
     */

  }, {
    key: "getCustomProperty",
    value: function getCustomProperty(key) {
      return this._customProperties.get(key);
    }
    /**
     * Returns an iterator which iterates over this element's custom properties.
     * Iterator provides `[ key, value ]` pairs for each stored property.
     *
     * @returns {Iterable.<*>}
     */

  }, {
    key: "getCustomProperties",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getCustomProperties() {
      return _regeneratorRuntime.wrap(function getCustomProperties$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.delegateYield(this._customProperties.entries(), "t0", 1);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, getCustomProperties, this);
    })
    /**
     * Returns identity string based on element's name, styles, classes and other attributes.
     * Two elements that {@link #isSimilar are similar} will have same identity string.
     * It has the following format:
     *
     *		'name class="class1,class2" style="style1:value1;style2:value2" attr1="val1" attr2="val2"'
    	 *
     * For example:
     *
     *		const element = writer.createContainerElement( 'foo', {
     *			banana: '10',
     *			apple: '20',
     *			style: 'color: red; border-color: white;',
     *			class: 'baz'
     *		} );
     *
     *		// returns 'foo class="baz" style="border-color:white;color:red" apple="20" banana="10"'
     *		element.getIdentity();
     *
     * **Note**: Classes, styles and other attributes are sorted alphabetically.
     *
     * @returns {String}
     */

  }, {
    key: "getIdentity",
    value: function getIdentity() {
      var classes = Array.from(this._classes).sort().join(',');

      var styles = this._styles.toString();

      var attributes = Array.from(this._attrs).map(function (i) {
        return "".concat(i[0], "=\"").concat(i[1], "\"");
      }).sort().join(' ');
      return this.name + (classes == '' ? '' : " class=\"".concat(classes, "\"")) + (!styles ? '' : " style=\"".concat(styles, "\"")) + (attributes == '' ? '' : " ".concat(attributes));
    }
    /**
     * Clones provided element.
     *
     * @protected
     * @param {Boolean} [deep=false] If set to `true` clones element and all its children recursively. When set to `false`,
     * element will be cloned without any children.
     * @returns {module:engine/view/element~Element} Clone of this element.
     */

  }, {
    key: "_clone",
    value: function _clone() {
      var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var childrenClone = [];

      if (deep) {
        var _iterator4 = _createForOfIteratorHelper(this.getChildren()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var child = _step4.value;
            childrenClone.push(child._clone(deep));
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } // ContainerElement and AttributeElement should be also cloned properly.


      var cloned = new this.constructor(this.document, this.name, this._attrs, childrenClone); // Classes and styles are cloned separately - this solution is faster than adding them back to attributes and
      // parse once again in constructor.

      cloned._classes = new Set(this._classes);

      cloned._styles.set(this._styles.getNormalized()); // Clone custom properties.


      cloned._customProperties = new Map(this._customProperties); // Clone filler offset method.
      // We can't define this method in a prototype because it's behavior which
      // is changed by e.g. toWidget() function from ckeditor5-widget. Perhaps this should be one of custom props.

      cloned.getFillerOffset = this.getFillerOffset;
      cloned._isAllowedInsideAttributeElement = this.isAllowedInsideAttributeElement;
      return cloned;
    }
    /**
     * {@link module:engine/view/element~Element#_insertChild Insert} a child node or a list of child nodes at the end of this node
     * and sets the parent of these nodes to this element.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#insert
     * @protected
     * @param {module:engine/view/item~Item|Iterable.<module:engine/view/item~Item>} items Items to be inserted.
     * @fires module:engine/view/node~Node#change
     * @returns {Number} Number of appended nodes.
     */

  }, {
    key: "_appendChild",
    value: function _appendChild(items) {
      return this._insertChild(this.childCount, items);
    }
    /**
     * Inserts a child node or a list of child nodes on the given index and sets the parent of these nodes to
     * this element.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#insert
     * @protected
     * @param {Number} index Position where nodes should be inserted.
     * @param {module:engine/view/item~Item|Iterable.<module:engine/view/item~Item>} items Items to be inserted.
     * @fires module:engine/view/node~Node#change
     * @returns {Number} Number of inserted nodes.
     */

  }, {
    key: "_insertChild",
    value: function _insertChild(index, items) {
      this._fireChange('children', this);

      var count = 0;
      var nodes = normalize(this.document, items);

      var _iterator5 = _createForOfIteratorHelper(nodes),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var node = _step5.value;

          // If node that is being added to this element is already inside another element, first remove it from the old parent.
          if (node.parent !== null) {
            node._remove();
          }

          node.parent = this;
          node.document = this.document;

          this._children.splice(index, 0, node);

          index++;
          count++;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return count;
    }
    /**
     * Removes number of child nodes starting at the given index and set the parent of these nodes to `null`.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#remove
     * @protected
     * @param {Number} index Number of the first node to remove.
     * @param {Number} [howMany=1] Number of nodes to remove.
     * @fires module:engine/view/node~Node#change
     * @returns {Array.<module:engine/view/node~Node>} The array of removed nodes.
     */

  }, {
    key: "_removeChildren",
    value: function _removeChildren(index) {
      var howMany = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this._fireChange('children', this);

      for (var i = index; i < index + howMany; i++) {
        this._children[i].parent = null;
      }

      return this._children.splice(index, howMany);
    }
    /**
     * Adds or overwrite attribute with a specified key and value.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#setAttribute
     * @protected
     * @param {String} key Attribute key.
     * @param {String} value Attribute value.
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_setAttribute",
    value: function _setAttribute(key, value) {
      value = String(value);

      this._fireChange('attributes', this);

      if (key == 'class') {
        parseClasses(this._classes, value);
      } else if (key == 'style') {
        this._styles.setTo(value);
      } else {
        this._attrs.set(key, value);
      }
    }
    /**
     * Removes attribute from the element.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#removeAttribute
     * @protected
     * @param {String} key Attribute key.
     * @returns {Boolean} Returns true if an attribute existed and has been removed.
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(key) {
      this._fireChange('attributes', this); // Remove class attribute.


      if (key == 'class') {
        if (this._classes.size > 0) {
          this._classes.clear();

          return true;
        }

        return false;
      } // Remove style attribute.


      if (key == 'style') {
        if (!this._styles.isEmpty) {
          this._styles.clear();

          return true;
        }

        return false;
      } // Remove other attributes.


      return this._attrs.delete(key);
    }
    /**
     * Adds specified class.
     *
     *		element._addClass( 'foo' ); // Adds 'foo' class.
     *		element._addClass( [ 'foo', 'bar' ] ); // Adds 'foo' and 'bar' classes.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#addClass
     * @protected
     * @param {Array.<String>|String} className
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_addClass",
    value: function _addClass(className) {
      this._fireChange('attributes', this);

      var _iterator6 = _createForOfIteratorHelper(toArray(className)),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var name = _step6.value;

          this._classes.add(name);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    /**
     * Removes specified class.
     *
     *		element._removeClass( 'foo' );  // Removes 'foo' class.
     *		element._removeClass( [ 'foo', 'bar' ] ); // Removes both 'foo' and 'bar' classes.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#removeClass
     * @protected
     * @param {Array.<String>|String} className
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_removeClass",
    value: function _removeClass(className) {
      this._fireChange('attributes', this);

      var _iterator7 = _createForOfIteratorHelper(toArray(className)),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var name = _step7.value;

          this._classes.delete(name);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
    /**
     * Adds style to the element.
     *
     *		element._setStyle( 'color', 'red' );
     *		element._setStyle( {
     *			color: 'red',
     *			position: 'fixed'
     *		} );
     *
     * **Note**: This method can work with normalized style names if
     * {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
     * See {@link module:engine/view/stylesmap~StylesMap#set `StylesMap#set()`} for details.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#setStyle
     * @protected
     * @param {String|Object} property Property name or object with key - value pairs.
     * @param {String} [value] Value to set. This parameter is ignored if object is provided as the first parameter.
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_setStyle",
    value: function _setStyle(property, value) {
      this._fireChange('attributes', this);

      this._styles.set(property, value);
    }
    /**
     * Removes specified style.
     *
     *		element._removeStyle( 'color' );  // Removes 'color' style.
     *		element._removeStyle( [ 'color', 'border-top' ] ); // Removes both 'color' and 'border-top' styles.
     *
     * **Note**: This method can work with normalized style names if
     * {@link module:engine/controller/datacontroller~DataController#addStyleProcessorRules a particular style processor rule is enabled}.
     * See {@link module:engine/view/stylesmap~StylesMap#remove `StylesMap#remove()`} for details.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#removeStyle
     * @protected
     * @param {Array.<String>|String} property
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_removeStyle",
    value: function _removeStyle(property) {
      this._fireChange('attributes', this);

      var _iterator8 = _createForOfIteratorHelper(toArray(property)),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var name = _step8.value;

          this._styles.remove(name);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
    /**
     * Sets a custom property. Unlike attributes, custom properties are not rendered to the DOM,
     * so they can be used to add special data to elements.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#setCustomProperty
     * @protected
     * @param {String|Symbol} key
     * @param {*} value
     */

  }, {
    key: "_setCustomProperty",
    value: function _setCustomProperty(key, value) {
      this._customProperties.set(key, value);
    }
    /**
     * Removes the custom property stored under the given key.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#removeCustomProperty
     * @protected
     * @param {String|Symbol} key
     * @returns {Boolean} Returns true if property was removed.
     */

  }, {
    key: "_removeCustomProperty",
    value: function _removeCustomProperty(key) {
      return this._customProperties.delete(key);
    }
    /**
     * Returns block {@link module:engine/view/filler filler} offset or `null` if block filler is not needed.
     *
     * @abstract
     * @method module:engine/view/element~Element#getFillerOffset
     */
    // @if CK_DEBUG_ENGINE // printTree( level = 0) {
    // @if CK_DEBUG_ENGINE // 	let string = '';
    // @if CK_DEBUG_ENGINE //	string += '\t'.repeat( level ) + `<${ this.name }${ convertMapToTags( this.getAttributes() ) }>`;
    // @if CK_DEBUG_ENGINE //	for ( const child of this.getChildren() ) {
    // @if CK_DEBUG_ENGINE //		if ( child.is( '$text' ) ) {
    // @if CK_DEBUG_ENGINE //			string += '\n' + '\t'.repeat( level + 1 ) + child.data;
    // @if CK_DEBUG_ENGINE //		} else {
    // @if CK_DEBUG_ENGINE //			string += '\n' + child.printTree( level + 1 );
    // @if CK_DEBUG_ENGINE //		}
    // @if CK_DEBUG_ENGINE //	}
    // @if CK_DEBUG_ENGINE //	if ( this.childCount ) {
    // @if CK_DEBUG_ENGINE //		string += '\n' + '\t'.repeat( level );
    // @if CK_DEBUG_ENGINE //	}
    // @if CK_DEBUG_ENGINE //	string += `</${ this.name }>`;
    // @if CK_DEBUG_ENGINE //	return string;
    // @if CK_DEBUG_ENGINE // }
    // @if CK_DEBUG_ENGINE // logTree() {
    // @if CK_DEBUG_ENGINE // 	console.log( this.printTree() );
    // @if CK_DEBUG_ENGINE // }

  }]);

  return Element;
}(Node); // Parses attributes provided to the element constructor before they are applied to an element. If attributes are passed
// as an object (instead of `Iterable`), the object is transformed to the map. Attributes with `null` value are removed.
// Attributes with non-`String` value are converted to `String`.
//
// @param {Object|Iterable} attrs Attributes to parse.
// @returns {Map} Parsed attributes.


export { Element as default };

function parseAttributes(attrs) {
  attrs = toMap(attrs);

  var _iterator9 = _createForOfIteratorHelper(attrs),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var _ref6 = _step9.value;

      var _ref5 = _slicedToArray(_ref6, 2);

      var key = _ref5[0];
      var value = _ref5[1];

      if (value === null) {
        attrs.delete(key);
      } else if (typeof value != 'string') {
        attrs.set(key, String(value));
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  return attrs;
} // Parses class attribute and puts all classes into classes set.
// Classes set s cleared before insertion.
//
// @param {Set.<String>} classesSet Set to insert parsed classes.
// @param {String} classesString String with classes to parse.


function parseClasses(classesSet, classesString) {
  var classArray = classesString.split(/\s+/);
  classesSet.clear();
  classArray.forEach(function (name) {
    return classesSet.add(name);
  });
} // Converts strings to Text and non-iterables to arrays.
//
// @param {String|module:engine/view/item~Item|Iterable.<String|module:engine/view/item~Item>}
// @returns {Iterable.<module:engine/view/node~Node>}


function normalize(document, nodes) {
  // Separate condition because string is iterable.
  if (typeof nodes == 'string') {
    return [new Text(document, nodes)];
  }

  if (!isIterable(nodes)) {
    nodes = [nodes];
  } // Array.from to enable .map() on non-arrays.


  return Array.from(nodes).map(function (node) {
    if (typeof node == 'string') {
      return new Text(document, node);
    }

    if (node instanceof TextProxy) {
      return new Text(document, node.data);
    }

    return node;
  });
}